module.exports = __webpack_public_path__ + "img/IMG-20220207-WA0034.3fdacd81.jpg";